import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const PhotoCarousel = () => {
  return (
  <Carousel autoPlay>
    <div>
      <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 1</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 2</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 3</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 4</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 5</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 6</p>
    </div>
    <div>
    <img alt="" src="https://images.unsplash.com/photo-1650289649023-11701cb4fc59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" />
      <p className="legend">Legend 7</p>
    </div>
    
  </Carousel>
  );
};
